import {StrapiImageProps} from "@/app/types/strapi.types";

const dayjs = require('dayjs');

export function getStrapiData(path:string, locale: string, filterString?: string, pageSize?: number ) {
    let localeString = '';
    let pageSizeString = '';
    let filter = '';

    if (locale) {
        localeString = locale
    } else {
        localeString = "personal"
    }

    if (pageSize) {
        pageSizeString = `&pagination[pageSize]=${pageSize}`
    }

    if (filterString) {
        filter = filterString
    }

    return `${process.env.NEXT_PUBLIC_STRAPI_URL}${path}?populate=deep&locale=${localeString}${filter}${pageSizeString}`;
}

export function getStrapiImageUrl(data: { data: StrapiImageProps }|undefined) {
    if(!data || !data.data) {
        return "";
    }
    const path = data.data.attributes.url;
    return `${path}`;
}

export function getStrapiImageUrlClean(data: string) {
    const path = data;
    return `${path}`;
}

export function getStrapiImageWidth(data: { data: StrapiImageProps }|undefined) {
    if(!data || !data.data) {
        return 0;
    }
    return data.data.attributes.width;
}

export function getStrapiImageHeight(data: { data: StrapiImageProps }|undefined) {
    if(!data || !data.data) {
        return 0;
    }
    return data.data.attributes.height;
}

export function getStrapiImageAlt(data: { data: StrapiImageProps }|undefined) {
    if(!data || !data.data) {
        return "";
    }
    return data.data.attributes.alternativeText;
}

export function convertToHoursAndMinutes(totalMinutes: number): string {
    if (totalMinutes < 0) {
        throw new Error("Total minutes cannot be negative.");
    }

    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;

    if (hours === 0) {
        return `${minutes}m`;
    } else {
        return minutes > 0 ? `${hours}h ${minutes}m` : `${hours}h`;
    }
}

export default function calculateAge(dob: string) {
    // Convert the date of birth to a Day.js object
    const birthDate = dayjs(dob);

    // Get the current date as a Day.js object
    const currentDate = dayjs();

    // Calculate the difference in years
    const age = currentDate.diff(birthDate, 'year');

    return age;
}
